import { render, staticRenderFns } from "./ProfileImg.vue?vue&type=template&id=30c08e2c&scoped=true&lang=pug&"
import script from "./ProfileImg.vue?vue&type=script&lang=js&"
export * from "./ProfileImg.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImg.vue?vue&type=style&index=0&id=30c08e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c08e2c",
  null
  
)

export default component.exports